import React, { useState } from "react";

import classes from "./PremiumCategory.module.css";

const PremiumCategory = ({ name, image, purchased, clicked }) => {
  const [locked, setLocked] = useState(name === "NSFW" && !purchased);
  const isMobile = window.innerWidth < 768;

  return (
    <button
      onClick={locked ? (isMobile ? () => setLocked(false) : null) : clicked}
      className={
        purchased
          ? `${classes.PremiumCategory} ${classes.Purchased}`
          : locked
          ? `${classes.PremiumCategory} ${classes.Locked}`
          : classes.PremiumCategory
      }
      style={
        locked
          ? {
              backgroundImage: `url(${
                require("../../../../illustrations/nsfw_blurred.png").default
              })`,
            }
          : {
              backgroundImage: `url(${image})`,
            }
      }
    >
      {!purchased ? (
        <>
          {locked ? (
            <div className={classes.LockedDesktop}>
              <p>
                Confirm you’re 18+ by clicking{" "}
                <button onClick={() => setLocked(false)}>here</button>.
              </p>
            </div>
          ) : null}
          <div className={classes.DesktopOverlay}></div>
        </>
      ) : null}
      <div>
        {locked && isMobile ? "Confirm you’re 18+ by tapping here" : name}
      </div>
    </button>
  );
};

export default PremiumCategory;
